// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"358":"a609c978","406":"1a89c0ce","464":"a609c978","541":"99d2b565","627":"a609c978","940":"b7ea4d91"}[chunkId] + ".chunk.css";
};